import { render, staticRenderFns } from "./index.vue?vue&type=template&id=980292aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=980292aa&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=980292aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980292aa",
  null
  
)

export default component.exports